module.exports = __webpack_public_path__ + "img/han-hsien.526509c4.jpg";